import { useState } from "react";
import UserProfile from "./UserProfile";
import UserSettings from "./UserSettings";

export default function ProfileSettings({ user, onUpdated }) {
  const [tab, setTab] = useState("profile");

  const tabs = [
    { key: "profile",  label: "Profile" },
    { key: "settings", label: "Settings" },
  ];

  return (
    <div style={{ fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      <h1 style={{ fontSize: 17, fontWeight: 700, color: "var(--ink)", marginBottom: 4 }}>
        {tab === "profile" ? "Profile" : "Settings"}
      </h1>

      <div style={{ display: "flex", gap: 0, borderBottom: "1px solid var(--border)", marginTop: 8, marginBottom: 24 }}>
        {tabs.map(({ key, label }) => (
          <button
            key={key}
            onClick={() => setTab(key)}
            style={{
              background: "none",
              border: "none",
              borderBottom: `2px solid ${tab === key ? "var(--ink)" : "transparent"}`,
              padding: "8px 18px",
              fontSize: 13,
              fontWeight: tab === key ? 700 : 400,
              color: tab === key ? "var(--ink)" : "var(--text-sub)",
              cursor: "pointer",
              fontFamily: "inherit",
              marginBottom: -1,
              transition: "all 0.12s",
            }}
          >
            {label}
          </button>
        ))}
      </div>

      {tab === "profile"  && <UserProfile  user={user} onUpdated={onUpdated} />}
      {tab === "settings" && <UserSettings user={user} />}
    </div>
  );
}
